import { useEffect, useRef, useState } from 'react'

const useCountDown = () => {
  const [countDown, setCountDown] = useState<number>(0)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const startCountDown = ({
    startingValueInSeconds,
  }: {
    startingValueInSeconds: number
  }) => {
    if (countDown === 0) {
      setCountDown(startingValueInSeconds)
      intervalRef.current = setInterval(() => {
        setCountDown((prev) => {
          if (prev > 0) {
            return prev - 1
          }
          return 0
        })
      }, 1000)
    }
  }

  useEffect(() => {
    if (countDown === 0 && intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }, [countDown])

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [])

  return {
    countDown,
    startCountDown,
  }
}

export default useCountDown
